<template>
  <div>
    <general-table
      :api-url="apiUrl"
      :columns="columns"
      :type="type"
      :top-header="topHeader"
    >
      <template #cell(is_internal)="data">
        <span>
          {{ data.item.training_session.is_internal ? '✅' : '❌' }}
        </span>
      </template>
      <template #cell(is_attended)="data">
        <span>
          {{ data.item.is_attended ? '✅' : '❌' }}
        </span>
      </template>
    </general-table>
  </div>
</template>

<script>
import GeneralTable from '@/components/general-table/GeneralTable.vue'

export default {
  components: { GeneralTable },
  data() {
    return {
      APIURL: '',
      type: 'page',
      partners: [],
      filter: {},
      types: '',
      columns: [
        { key: 'id', sortable: true },
        { key: 'training_session.from', label: 'From' },
        { key: 'training_session.to', label: 'To' },
        { key: 'is_internal', label: 'Is Internal ?' },
        { key: 'training_session.trainer', label: 'Trainer Name' },
        { key: 'training_session.training_venue', label: 'Training Venue' },
        { key: 'training.name', label: 'Name' },
        { key: 'is_attended', label: 'Is Attended?' },
        // { key: 'certificate_file', label: 'File' },
      ],
      topHeader: [
        { lable: '', colspan: 1 },
        { lable: ' Training Session', colspan: 5 },
        { lable: 'Training', colspan: 1 },
        { lable: '', colspan: 1 },

      ],
    }
  },

  computed: {

    apiUrl() {
      let base = `engineer/${this.$route.params.id}/training-session-attend?`

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      // console.log(base.slice(0, -1))
      return base.slice(0, -1)
    },
  },

  methods: {

    filterTypes(type) {
      const filteredType = this.status.filter(item => item.text !== type)
      this.types = filteredType
    },

  },
}
</script>

  <style></style>
